import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataProcess = parseToMutationRequest(data, ['formatType']);
  const processBatchPayment = `processBatchPayment(input: ${dataProcess})`;
  return gql`
  mutation {
    ${processBatchPayment}
  }
`;
};
